__turbopack_context__.v({
  "files": "DemoContentLoading-module__mMvPaq__files",
});
